import { render, staticRenderFns } from "./VariantCallsLaunch.vue?vue&type=template&id=8d83c194"
import script from "./VariantCallsLaunch.vue?vue&type=script&lang=ts"
export * from "./VariantCallsLaunch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports